import { render } from "./RecaptchaSubmitButton.vue?vue&type=template&id=acedc49a&ts=true"
import script from "./RecaptchaSubmitButton.vue?vue&type=script&lang=ts"
export * from "./RecaptchaSubmitButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__